import styled from 'styled-components';
import { theme } from '@frameio/vapor-theme';

export const ContentContainer = styled.div<{
  tabletPickerWidth: number;
  desktopPickerWidth: number;
}>`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces[32]};
  justify-content: space-between;
  padding: ${theme.spaces[24]};

  @media (min-width: ${theme.breakpoints.tablet}) {
    padding: calc(${theme.spaces[32]} + ${theme.spaces[8]});
    align-items: start;
    display: grid;
    gap: calc(${theme.spaces[32]} + ${theme.spaces[8]});
    grid-template-columns: auto ${({ tabletPickerWidth }) =>
        tabletPickerWidth}px;
  }

  @media (min-width: ${theme.breakpoints.desktop}) {
    display: grid;
    gap: calc(${theme.spaces[32]} + ${theme.spaces[8]});
    grid-template-columns: auto ${({ desktopPickerWidth }) =>
        desktopPickerWidth}px;
  }
`;

export const ContentColumn = styled.div<{ grow?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  position: relative;
  ${({ grow }) => (grow ? `width: 100%` : `flex: 0 0 auto`)};
`;

export const FooterContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  height: ${theme.spaces[64]};
  padding: ${theme.spaces[16]};
`;

export const IncludeAssetsWrapper = styled.div<{ $disabled: boolean }>`
  align-items: center;
  display: flex;
  ${(p) => p.$disabled && 'opacity: 0.5;'}
`;
